import React from 'react';
import { Spin } from 'antd';

export default function LoadingScreen() {
  return (
    <Spin
      className="h-screen w-screen flex justify-center items-center"
      size={'large'}
    />
  );
}
